import { combineReducers } from 'redux';

import activeAlarms from '@slices/activeAlarms';
import activeAlarmsFlexidas from '@slices/activeAlarmsFlexidas';
import alarmHistory from '@slices/alarmHistory';
import alarmHistoryFlexidas from '@slices/alarmHistoryFlexidas';
import alarmManagement from '@slices/alarmManagement';
import alarmManagementFlexidas from '@slices/alarmManagementFlexidas';
import allCells from '@slices/allCells';
import approveUnit from '@slices/approveUnit';
import assetCartRequestAvailableList from '@slices/assetCartRequestAvailableList';
import assetCartRequestFullView from '@slices/assetCartRequestFullView';
import assetCartRequestUnavailableList from '@slices/assetCartRequestUnavailableList';
import assetHistory from '@slices/assetHistory';
import assetProfileIncomingRequests from '@slices/assetProfileIncomingRequests';
import assetProfileOutgoingRequests from '@slices/assetProfileOutgoingRequests';
import assets from '@slices/assets';
import assetsRentIncomingRequests from '@slices/assetsRentIncomingRequests';
import assetsRentOutgoingRequests from '@slices/assetsRentOutgoingRequests';
import assignApprovalUnit from '@slices/assignApprovalUnit';
import auth from '@slices/auth';
import common from '@slices/common';
import configurationManagement from '@slices/configurationManagement';
import crowdCells from '@slices/crowdCells';
import dashboardPOAssetTypesTable from '@slices/dashboardPOAssetTypesTable';
import dashboardPORequestsTable from '@slices/dashboardPORequestsTable';
import dashboardPOStatusesTable from '@slices/dashboardPOStatusesTable';
import dataSourceGNBConfiguration from '@slices/dataSourceGNBConfiguration';
import errors from '@slices/errors';
import importMapData from '@slices/importMapData';
import kpi from '@slices/kpi';
import kpiAlerts from '@slices/kpiAlerts';
import manageAcquiredAssets from '@slices/manageAcquiredAssets';
import map from '@slices/map';
import moBranch from '@slices/moBranch';
import moBranches from '@slices/moBranches';
import notifications from '@slices/notifications';
import organisationBranding from '@slices/organisationBranding';
import organisationProjects from '@slices/organisationProjects';
import organisations from '@slices/organisations';
import organisationSettings from '@slices/organisationSettings';
import portalFiles from '@slices/portalFiles';
import portalFolders from '@slices/portalFolders';
import portalMilestones from '@slices/portalMilestones';
import portalProjects from '@slices/portalProjects';
import portalTasks from '@slices/portalTasks';
import portalTimeline from '@slices/portalTimeline';
import schemaConfig from '@slices/schemaConfig';
import sectors from '@slices/sectors';
import sites from '@slices/sites';
import userHistory from '@slices/userHistory';
import users from '@slices/users';

export const rootReducer = combineReducers({
	activeAlarms,
	activeAlarmsFlexidas,
	alarmHistory,
	alarmHistoryFlexidas,
	alarmManagement,
	alarmManagementFlexidas,
	allCells,
	approveUnit,
	assetCartRequestAvailableList,
	assetCartRequestFullView,
	assetCartRequestUnavailableList,
	assetHistory,
	assetProfileIncomingRequests,
	assetProfileOutgoingRequests,
	assets,
	assetsRentIncomingRequests,
	assetsRentOutgoingRequests,
	assignApprovalUnit,
	auth,
	common,
	configurationManagement,
	crowdCells,
	dashboardPOAssetTypesTable,
	dashboardPORequestsTable,
	dashboardPOStatusesTable,
	dataSourceGNBConfiguration,
	errors,
	importMapData,
	kpi,
	kpiAlerts,
	manageAcquiredAssets,
	map,
	moBranch,
	moBranches,
	notifications,
	organisationBranding,
	organisationProjects,
	organisationSettings,
	organisations,
	portalFiles,
	portalFolders,
	portalMilestones,
	portalProjects,
	portalTasks,
	portalTimeline,
	schemaConfig,
	sectors,
	sites,
	userHistory,
	users,
});

export type TRootReducer = typeof rootReducer;
export type TAppRootState = ReturnType<TRootReducer>;
